import { render, staticRenderFns } from "./ciudades.vue?vue&type=template&id=3682c2fe&scoped=true&"
import script from "./ciudades.vue?vue&type=script&lang=js&"
export * from "./ciudades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3682c2fe",
  null
  
)

export default component.exports